var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIconsAutomation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "automation__Property 1=Automation, State=Default",
    className: "automation__Property automation__1=Automation, automation__State=Default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "automation__ai-vehicle-spark-1--car-automated-transportation-artificial-intelligence-ai",
    className: "automation__ai-vehicle-spark-1--car-automated-transportation-artificial-intelligence-ai"
  }, /*#__PURE__*/React.createElement("path", {
    id: "automation__Vector 2136 (Stroke)",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.845 2.797c-.031.025-.077.077-.1.191l-.064.31c-.882 4.313-4.125 7.668-8.256 8.438-.067.012-.098.039-.12.07A.34.34 0 0 0 3.25 12a.34.34 0 0 0 .055.195c.022.031.053.058.12.07 4.13.77 7.374 4.125 8.256 8.438l.064.31c.023.114.069.166.1.19a.22.22 0 0 0 .136.047.22.22 0 0 0 .136-.045c.03-.024.077-.075.101-.19l.077-.36c.915-4.292 4.158-7.618 8.276-8.384.068-.013.1-.04.123-.072A.346.346 0 0 0 20.75 12a.345.345 0 0 0-.056-.198.177.177 0 0 0-.123-.073c-4.118-.766-7.361-4.092-8.276-8.384l-.077-.36c-.024-.115-.07-.166-.101-.19a.218.218 0 0 0-.136-.045.22.22 0 0 0-.136.046Zm1.84-.124c-.406-1.907-3.02-1.89-3.41.015l-.063.31c-.77 3.765-3.58 6.615-7.061 7.263-.964.18-1.401 1.018-1.401 1.74s.437 1.56 1.4 1.74c3.482.648 6.292 3.498 7.062 7.263l.063.31c.39 1.905 3.004 1.922 3.41.015l.077-.36c.799-3.75 3.61-6.576 7.083-7.223.967-.18 1.405-1.02 1.405-1.745 0-.724-.438-1.565-1.405-1.745-3.473-.647-6.284-3.474-7.083-7.222l-.077-.361Z",
    className: "automation__Vector automation__2136 automation__(Stroke)",
    clipRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconsAutomation);
export default __webpack_public_path__ + "static/media/sidebar-icons-automation.2b2843ac0ad716bbabfa119215a85c8d.svg";
export { ForwardRef as ReactComponent };